'use client';

import classNames from 'classnames';
import { StaticImageData } from 'next/image';
import type { ComponentProps } from 'react';
import Image from '@alltrails/core/components/Image';
import Heading from '@alltrails/denali/components/Heading';
import IconButton from '@alltrails/denali/components/IconButton';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import ArrowRec from '@alltrails/denali/icons/ArrowRec';
import styles from './styles/styles.module.scss';

type HeroImageProps = {
  alt: string;
  headerText: string;
  headerSubText: string;
  linkInfo?: ComponentProps<typeof IconButton>['linkInfo'];
  onArrowClick?: () => void;
  imageData: { mobileSrc: StaticImageData; src: StaticImageData };
  textContainerStyles?: string;
  quality?: number;
  ariaLabel?: string;
};

const HeroImage = ({
  alt,
  onArrowClick,
  headerText,
  headerSubText,
  linkInfo,
  imageData,
  textContainerStyles,
  quality,
  ariaLabel
}: HeroImageProps) => {
  const isMobile = useIsMobileSizedScreen();
  const { src, mobileSrc } = imageData;
  return (
    <div className={styles.container}>
      <Image src={isMobile ? mobileSrc : src} alt={alt} className={styles.hero} priority fill quality={quality} />
      <div className={classNames(styles.innerContainer, textContainerStyles)}>
        <Heading as="h1" className={styles.headerText} color="inverse" size="300">
          {headerText}
        </Heading>
        <Heading as="h2" className={styles.headerSubtext} color="inverse" size="700">
          {headerSubText}
        </Heading>
      </div>
      <div className={styles.largeArrow}>
        <IconButton
          icon={{ Component: ArrowRec, orientation: 'down' }}
          linkInfo={linkInfo}
          onClick={onArrowClick}
          ariaLabel={ariaLabel}
          title={alt}
          size="lg"
          variant="insetLight"
        />
      </div>
    </div>
  );
};

export default HeroImage;
